/** The most rows core's list returns in one call; the screens filter on the client. */
export const APPLICATIONS_LIMIT = 200;
